import { render, staticRenderFns } from "./RedNoticeBanner.vue?vue&type=template&id=a7525b44&"
import script from "./RedNoticeBanner.vue?vue&type=script&lang=js&"
export * from "./RedNoticeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports